import { configureStore } from '@reduxjs/toolkit';
import snackbarReducer from './snackbar';
import loadingReducer from './loading';
import stepReducer from './step';
import customerReducer from './customer';
import vehiclesReducer from './vehicles';
import vehicleReducer from './vehicle';
import dealersReducer from './dealers';
import campaignsReducer from './campaigns';
import appointmentNotesReducer from './appointmentNotes';
import formReducer from './form';
import formerDealerReducer from './formerDealer';
import portLoginReducer from './portLogin';
import timeSlotsReducer from './timeSlots';
import appointmentReducer from './appointment';
import utmValuesReducer from './utmValues';

export default configureStore({
    reducer: {
        snackbar: snackbarReducer,
        loading: loadingReducer,
        step: stepReducer,
        portLogin: portLoginReducer,
        customer: customerReducer,
        vehicles: vehiclesReducer,
        vehicle: vehicleReducer,
        dealers: dealersReducer,
        campaigns: campaignsReducer,
        appointmentNotes: appointmentNotesReducer,
        form: formReducer,
        formerDealer: formerDealerReducer,
        timeSlots: timeSlotsReducer,
        appointment: appointmentReducer,
        utmValues: utmValuesReducer
    },
    devTools: process.env.NODE_ENV !== 'production',
});